import React from 'react';

import { useIntl } from 'react-intl-next';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import AtlaskitEmptyState from '@atlaskit/empty-state';
import { Anchor } from '@atlaskit/primitives';
import { fireUIAnalytics } from '@atlassian/analytics-bridge';
import { IPHAnchor } from '@atlassian/eoc-iph-store';

import { OptionalSupportUrlKeys } from '../../common/types';
import { AutoCreateButton } from '../../common/ui/auto-create-button';
import { CreateButton } from '../../common/ui/create-button';
import { useHeartbeatsContext } from '../../controllers/providers/heartbeats';

import { CustomSVG } from './image';
import messages from './messages';

export const EmptyState = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { formatMessage } = useIntl();

	const { supportUrls } = useHeartbeatsContext();

	const whatAreHeartbeatsUrl = supportUrls[OptionalSupportUrlKeys.WHAT_ARE_HEARTBEATS];

	return (
		<AtlaskitEmptyState
			header={formatMessage(messages.title)}
			description={formatMessage(messages.description, {
				linkReadMore: (msg: React.ReactNode) =>
					whatAreHeartbeatsUrl ? (
						<Anchor
							href={whatAreHeartbeatsUrl}
							target="_blank"
							rel="noopener noreferrer"
							onClick={(e) => {
								e.stopPropagation();
								const event = createAnalyticsEvent({});
								fireUIAnalytics(event, 'link clicked', 'learnMore');
							}}
						>
							{msg}
						</Anchor>
					) : (
						<IPHAnchor
							id="heartbeats-empty-state"
							requiresDot
							onClick={(e) => {
								e.stopPropagation();
								const event = createAnalyticsEvent({});
								fireUIAnalytics(event, 'link clicked', 'learnMore');
							}}
						>
							{msg}
						</IPHAnchor>
					),
			})}
			headingLevel={3}
			primaryAction={<CreateButton />}
			secondaryAction={<AutoCreateButton />}
			renderImage={() => <CustomSVG />}
		/>
	);
};
